import { render, staticRenderFns } from "./ImageMarginGroup.vue?vue&type=template&id=ea81e5cc&"
import script from "./ImageMarginGroup.vue?vue&type=script&lang=js&"
export * from "./ImageMarginGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports